<div class="vessel-container">
    <div class="container-tabs">
        <div
            class="tab"
            data-cy="mimics-mimics-tab"
            [class.selected]="selectedTab === TABS.mimic"
            (click)="selectTab(TABS.mimic)">
            {{ 'editor.navigation.tab.mimic' | translate }}
        </div>
        <div
            class="tab"
            data-cy="mimics-components-tab"
            [class.selected]="selectedTab === TABS.component"
            (click)="selectTab(TABS.component)">
            {{ 'editor.navigation.tab.component' | translate }}
        </div>
    </div>
    <app-mimic-tab
        class="tab-container"
        *ngIf="selectedTab === TABS.mimic"
        [canCreateOrDelete]="canCreateOrDelete"
        [showOptionsAll]="showOptionsAll"
        [showOption]="showOption"
        [rootList]="rootList"
        [selectedMimic]="selectedMimic"
        [vessel]="vessel"
        (onCreateMimic)="createMimic($event)"
        (onPrintAll)="printAll()"
        (onSelectMimic)="selectMimic($event)"
        (onDeleteMimic)="deleteMimic($event)"
        (onDuplicateMimic)="duplicateMimic($event)"
        (onDeleteMimicFolder)="deleteMimicFolder($event)"
        (onPrintMimic)="printMimic($event)"
        (onOpenExpanded)="openFolderExpanded($event)">
    </app-mimic-tab>
    <app-library-tab
        class="tab-container"
        *ngIf="selectedTab === TABS.component"
        [vessel]="vessel"
        [libraryList]="libraryList"
        [canCreateOrDelete]="canCreateOrDelete"
        [showOptionsAll]="showOptionsAll"
        [showOption]="showOption"
        [selectedCategory]="selectedCategory"
        (onOpenCategoryOption)="openCategoryOptions($event)"
        (onOpenComponentDialog)="openComponentDialog($event)"
        (onCloseComponentDialog)="closeComponentDialog()"
        (onDeleteLibrary)="deleteLibrary($event)"
        (onCloseCategoryOption)="closeCategoryOption()"
        (onOpenExpanded)="openLibraryExpanded($event)">
    </app-library-tab>
</div>

<div #libraryComponentDialog>
    <app-library-component-dialog
        class="component-dialog"
        [class.hidden]="!showComponentDialog || selectedCategory?.id?.startsWith('default-')"
        [x]="COMPONENT_DAILOG_LEFT"
        [y]="COMPONENT_DAILOG_TOP"
        [selectedCategory]="selectedCategory"
        [componentList]="selectedCategoryComponentList"
        (onDeleteComponent)="deleteLibraryComponent($event)"></app-library-component-dialog>
    <app-default-component-dialog
        class="component-dialog"
        [class.hidden]="!showComponentDialog || !selectedCategory?.id?.startsWith('default-')"
        [x]="COMPONENT_DAILOG_LEFT"
        [y]="COMPONENT_DAILOG_TOP"
        [selectedCategoryId]="selectedCategory?.id"></app-default-component-dialog>
</div>

<div class="layout-container">
    <div class="vessel-dropdown">
        <h3 class="vessel-title">{{ 'mimic-drawing.layers' | translate }}</h3>
    </div>
    <app-layers-menu></app-layers-menu>
</div>

<div style="display: none">
    <div id="print-mimics" #images></div>
</div>

<div class="category-more-options" #categoryOptions [class.hidden]="!showCategoryOption">
    <div class="more-options-container">
        <div class="button" (click)="deleteLibraryCategory()" [class.disabledOption]="!canCreateOrDelete">
            <mat-icon svgIcon="delete" class="icon" />
            {{ 'mimic.page.button.delete' | translate }}
        </div>
        <div class="button" (click)="openEditLibraryCategoryDialog()" [class.disabledOption]="!canCreateOrDelete">
            <mat-icon svgIcon="edit-pen" class="icon" />
            {{ 'mimic.page.button.edit' | translate }}
        </div>
        <div class="button" (click)="duplicateLibraryCategory()" [class.disabledOption]="!canCreateOrDelete">
            <mat-icon svgIcon="duplicate" class="icon" />
            {{ 'mimic.page.button.duplicate' | translate }}
        </div>
    </div>
</div>
